import { render, staticRenderFns } from "./CommunityGas.vue?vue&type=template&id=58bcf963&scoped=true"
import script from "./CommunityGas.vue?vue&type=script&lang=js"
export * from "./CommunityGas.vue?vue&type=script&lang=js"
import style0 from "./CommunityGas.vue?vue&type=style&index=0&id=58bcf963&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bcf963",
  null
  
)

export default component.exports